module.exports = ".search-bar-container {\n    width: 100%;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/pages/iglesias/lista-iglesias/lista-iglesias.component.css
// module id = ./src/app/admin/pages/iglesias/lista-iglesias/lista-iglesias.component.css
// module chunks = main